let infiniteScrollInitialized = false;

function initCollectionInfiniteScroll() {
  const grid = document.getElementById('main-collection-product-grid');
  const loader = document.getElementById('infinite-scroll-loader');
  if (!grid || !loader) return;

  let currentPage = parseInt(grid.getAttribute('data-current-page') || '1', 10);
  let loading = false;
  let maxPages = parseInt(grid.getAttribute('data-max-pages') || '1', 10);
  const sectionId = grid.getAttribute('data-id');

  function loadNextPage() {
    if (loading) return;
    if (currentPage >= maxPages) {
      loader.style.display = 'none';
      loading = false;
      return;
    }
    loading = true;
    loader.style.display = 'block';
    const nextPage = currentPage + 1;
    // Build the request URL from the *current* location so that any active
    // sort_by / filter.* params are preserved. Use section_id rendering so we
    // only fetch the grid markup, not the whole page.
    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);
    if (sectionId) url.searchParams.set('section_id', sectionId);

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newGrid = tempDiv.querySelector('#main-collection-product-grid');
        if (newGrid) {
          while (newGrid.firstElementChild) {
            grid.appendChild(newGrid.firstElementChild);
          }
          currentPage = nextPage;
          grid.setAttribute('data-current-page', String(currentPage));
        }
        if (currentPage >= maxPages) {
          loader.style.display = 'none';
        } else {
          loader.style.display = 'block';
        }
        loading = false;
      })
      .catch(() => {
        loader.style.display = 'none';
        loading = false;
      });
  }

  // Remove previous scroll event if already initialized
  if (infiniteScrollInitialized) {
    window.removeEventListener('scroll', window._infiniteScrollHandler);
  }

  window._infiniteScrollHandler = function() {
    if (loading || currentPage >= maxPages) return;
    const rect = loader.getBoundingClientRect();
    if (rect.top < window.innerHeight + 100) {
      loadNextPage();
    }
  };

  window.addEventListener('scroll', window._infiniteScrollHandler);
  infiniteScrollInitialized = true;
}

document.addEventListener('DOMContentLoaded', function() {
  initCollectionInfiniteScroll();
});

// Listen for custom 'renderProductGrid' event to re-initialize infinite scroll
window.addEventListener('renderProductGrid', function() {
  initCollectionInfiniteScroll();
});